<template>
  <div class="lease-item-step-manage-bd">
    <el-form :inline="true" @submit.native.prevent :disabled="type === 'watch'">
      <el-form-item>
        <el-button type="primary" icon="el-icon-plus" @click="addLeaseDialog()">{{ $t('crm_lease_item_step_manage.tjzlfa') }}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="onUnifiedDialog" :disabled="!tableList.length">{{ $t('crm_lease_item_step_manage.szzlfa') }}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="onFalsifyDialog(tableList[0], true)" :disabled="!tableList.length">{{ $t('crm_lease_item_step_manage.szwyfa') }}</el-button>
      </el-form-item>
    </el-form>
    <div class="table-bd">
      <custom-table
        type="radio"
        v-model="radio"
        :default-expand-all="true"
        :index="true"
        :expand="true"
        :data="tableList"
        :column="tableColumn"
        @sort="sortChange"
        @filter="filterChange"
        :slots="['rentalTermMin', 'custom1', 'custom2', 'custom3', 'custom4', 'action']"
      >
        <template slot="expand" slot-scope="scope2">
          <el-table :size="allTableSize" :data="scope2.row.sharingList" style="width: 100%">
            <el-table-column prop="sharingClass" :label="$t('crm_lease_item_step_manage.fen_cheng_fang_an')" width="100"></el-table-column>
            <el-table-column :label="$t('crm_lease_item_step_manage.jfdbysy')" width="200">
              <template slot-scope="scope">
                <el-input
                  :disabled="type === 'watch'"
                  type="number"
                  :min="0"
                  v-model="scope.row.agentCoProfit"
                  placeholder
                  style="width: 150px"
                  @change="formatPriceItem(scope2.row, scope.row)"
                  @blur="blurFormatNum(scope.row, 'agentCoProfit', scope.row.agentCoProfit)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('crm_lease_item_step_manage.shgsysy')" width="200">
              <template slot-scope="scope">
                <el-input
                  :disabled="type === 'watch'"
                  type="number"
                  :min="0"
                  v-model="scope.row.afterServiceProfit"
                  placeholder
                  style="width: 150px"
                  @change="formatPriceItem(scope2.row, scope.row)"
                  @blur="blurFormatNum(scope.row, 'afterServiceProfit', scope.row.afterServiceProfit)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('crm_lease_item_step_manage.zbysy')" width="200">
              <template slot-scope="scope">
                <el-input disabled type="number" :min="0" v-model="scope.row.hqProfit" placeholder style="width: 150px"></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('crm_lease_item_step_manage.zbysjzy')" width="200">
              <template slot-scope="scope">
                <el-input
                  :disabled="type === 'watch'"
                  type="number"
                  :min="0"
                  v-model="scope.row.hqBasicProfit"
                  placeholder
                  style="width: 150px"
                  @blur="blurFormatNum(scope.row, 'hqBasicProfit', scope.row.hqBasicProfit)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column :label="$t('crm_lease_item_step_manage.sqksblx')">
              <template slot-scope="scope">
                <custom-select
                  @change="changeFirstTerm(scope2.row.sharingList, scope.$index)"
                  :clearable="false"
                  v-model.number="scope.row.isFirstTerm"
                  :data="cloud_bool"
                  width="150px"
                ></custom-select>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <template slot="rentalTermMin" slot-scope="scope">{{ scope.row.rentalTermMin }} - {{ scope.row.rentalTermMax }}</template>
        <!-- 押金 -->
        <template slot="custom1" slot-scope="scope">
          <el-input
            :disabled="type === 'watch'"
            type="number"
            :min="0"
            v-model="scope.row.depositFee"
            placeholder
            style="width: 100%"
            @blur="blurFormatNum(scope.row, 'depositFee', scope.row.depositFee)"
          ></el-input>
        </template>
        <!-- 租金 -->
        <template slot="custom2" slot-scope="scope">
          <el-input
            :disabled="type === 'watch'"
            type="number"
            :min="0"
            v-model="scope.row.unitPrice"
            placeholder
            style="width: 100%"
            @change="formatPrice(scope.row)"
            @blur="blurFormatNum(scope.row, 'unitPrice', scope.row.unitPrice)"
          ></el-input>
        </template>
        <!-- 售后附加费 -->
        <template slot="custom3" slot-scope="scope">
          <el-input
            :disabled="type === 'watch'"
            type="number"
            :min="0"
            v-model="scope.row.additionalFee"
            placeholder
            style="width: 100%"
            @blur="blurFormatNum(scope.row, 'additionalFee', scope.row.additionalFee)"
          ></el-input>
        </template>
        <!-- 赠送月数 -->
        <template slot="custom4" slot-scope="scope">
          <el-input :disabled="type === 'watch'" type="number" :min="0" v-model="scope.row.giveawayMonth" placeholder style="width: 100%"></el-input>
        </template>
        <template slot-scope="scope" slot="action">
          <span></span>
          <el-button :disabled="type === 'watch'" type="text" size="mini" @click="deleteEvent(scope.row, scope.$index)">{{ $t('Common.com_delete') }}</el-button>
          <el-button :disabled="scope.row.paymentPeriod === '0' || type === 'watch'" type="text" size="mini" @click="onFalsifyDialog(scope.row)">{{ $t('crm_lease_item_step_manage.szwyfa') }}</el-button>
          <el-button type="text" size="mini" @click="onPreviewDialog(scope.row)">{{ $t('crm_lease_item_step_manage.yu_lan') }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="footer" v-if="type !== 'watch'">
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button @click="onBack">{{ $t('crm_lease_item_step_manage.shang_yi_bu') }}，{{ $t('crm_lease_item_step_manage.fajbxxsz') }}</el-button>
      <el-button type="primary" @click="onSave()">{{ $t('Common.com_save') }}</el-button>
    </div>
    <step-manage-add-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getTableList"></step-manage-add-dialog>
    <step-manage-unified-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="onUnifiedSuccess"></step-manage-unified-dialog>
    <step-manage-falsify-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false"></step-manage-falsify-dialog>
    <step-manage-preview-dialog v-if="dialogVisible3" :model="dialogModel3" @close="dialogVisible3 = false"></step-manage-preview-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import stepManagePreviewDialog from '@/pages/crm/components/managePreviewDialog';
import stepManageAddDialog from './step_manage_add_dialog.vue';
import stepManageUnifiedDialog from './step_manage_unified_dialog';
import stepManageFalsifyDialog from './step_manage_falsify_dialog';

export default {
  components: {
    stepManageAddDialog,
    stepManageUnifiedDialog,
    stepManageFalsifyDialog,
    stepManagePreviewDialog,
  },
  props: {
    productCode: [String, Number],
    goodsId: [String, Number],
    dialog: [Boolean],
  },
  data() {
    return {
      radio: {},
      type: '',
      tableCode: 'leaseManage',
      formSearch: {
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
      },
      form: {
        rentalSharingId: '',
        sharingClass: '',
        agentCoProfit: '',
        afterServiceProfit: '',
        hqProfit: '',
        hqBasicProfit: '',
        isFirstTerm: 0,
      },
      itemsForm: {},
      tableList: [],
      totalRows: 0,
      ruleList: [],
      cloud_bool: [],

      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
      dialogVisible2: false,
      dialogModel2: {},
      dialogVisible3: false,
      dialogModel3: {},
    };
  },
  mounted: function () {
    this.type = this.getJump('type') || (this.getJump('goodsId') ? 'edit' : 'add');
    this.getDictionary('isynergy_cloud_bool', (data) => {
      this.cloud_bool = data.isynergy_cloud_bool;
    });
    this.getTableColumn();
    this.getSharingRuleList(() => {
      this.itemsForm = this.ruleList.map((t) => {
        const obj = { sharingClass: t.sharingClass, sharingCondition: t.sharingCondition, sharingConditionView: t.sharingConditionView, firstDeviceBizType: [] };
        return Object.assign({}, this.form, obj);
      });
      this.getTableList();
    });
  },
  methods: {
    changeFirstTerm: function (list, index) {
      const item = list[index] || {};
      if (item.isFirstTerm === 1) {
        list.forEach((row, idx) => {
          if (idx !== index) {
            row.isFirstTerm = 0;
          }
        });
      }
    },
    // 取消
    onCancel: function () {
      this.$emit('cancel');
    },
    // 返回
    onBack: function () {
      this.$emit('back');
    },
    // 经度转换
    blurFormatNum: function (row, key, value) {
      const digit = 2;
      row[key] = Math.round(Number.parseFloat(`${value}`) * 10 ** digit) / 10 ** digit;
    },
    // 总部应收计算
    formatPrice: function () {
      this.tableList.forEach((item) => {
        item.sharingList.forEach((row) => {
          const digit = 2;
          const value = Number.parseFloat(item.unitPrice || 0) - Number.parseFloat(row.agentCoProfit || 0) - Number.parseFloat(row.afterServiceProfit || 0);
          row.hqProfit = Math.round(Number.parseFloat(`${value}`) * 10 ** digit) / 10 ** digit;
          row.hqBasicProfit = Math.round(Number.parseFloat(`${value}`) * 10 ** digit) / 10 ** digit;
        });
      });
      // this.formatIsFirstTerm(currentRow);
    },
    // 计算基准
    formatPriceItem: function (item, row) {
      const digit = 2;
      const value = Number.parseFloat(item.unitPrice || 0) - Number.parseFloat(row.agentCoProfit || 0) - Number.parseFloat(row.afterServiceProfit || 0);
      row.hqProfit = Math.round(Number.parseFloat(`${value}`) * 10 ** digit) / 10 ** digit;
      row.hqBasicProfit = Math.round(Number.parseFloat(`${value}`) * 10 ** digit) / 10 ** digit;
    },
    // 规则字符串： "(unitPrice >= 830 || totalReceivedRentalHq < 13776)"
    // 连接符： >,!=,>=,<,<=,==
    computedUnitPrice: function (ruleString, num) {
      const regex = /unitPrice\s*([><=!]+)\s*(\d+)/;
      const match = ruleString.match(regex);
      const operator = match[1];
      const value = match[2];
      let result = false;
      if (!operator || !value) {
        return result;
      }
      switch (operator) {
        case '>':
          result = Number(num || '0') > Number(value);
          break;
        case '>=':
          result = Number(num || '0') >= Number(value);
          break;
        case '<':
          result = Number(num || '0') < Number(value);
          break;
        case '<=':
          result = Number(num || '0') <= Number(value);
          break;
        case '!=':
          result = Number(num || '0') !== Number(value);
          break;
        case '==':
          result = Number(num || '0') === Number(value);
          break;
        default:
      }
      return result;
    },
    // 格式化是否首期设备类型
    formatIsFirstTerm: function (row) {
      // 原来只有AB分成2个方案的设备业务类型 初始化规则
      // 1.A、B类型机器时使用A分成 计算首期款
      // 2.C、D、F类型机器时根据月租金进行判断，月租金匹配A分成规则 则使用A分成 计算首期款，否则使用B分成规则计算首期款
      const sharingClass = this.ruleList.map((t) => t.sharingClass).join(',');
      const sharingACondition = (this.ruleList.find((t) => t.sharingClass === 'A') || { sharingCondition: '' }).sharingCondition; // A分成规则
      const deviceBizType = row.deviceBizType;
      if (sharingClass === 'A,B') {
        row.sharingList.forEach((item) => {
          let bizCode = '';
          if (['A', 'B'].includes(deviceBizType)) {
            bizCode = 'A';
          } else {
            const result = this.computedUnitPrice(sharingACondition, row.unitPrice);
            bizCode = result ? 'A' : 'B';
          }
          item.isFirstTerm = item.sharingClass === bizCode ? 1 : 0;
        });
      } else if (sharingClass === 'A,B,C') {
        // 原来有ABC 分成3个方案的设备业务类型 初始化规则
        // 1.A类型 使用A分成 计算首期款 (未变化)
        // 2.B类型使用B分成计算首期款(未变化)
        // 3.C、D、F类型机器使用C分成计算首期款
        row.sharingList.forEach((item) => {
          let bizCode = '';
          if (['A', 'B'].includes(deviceBizType)) {
            bizCode = deviceBizType;
          } else {
            bizCode = 'C';
          }
          item.isFirstTerm = item.sharingClass === bizCode ? 1 : 0;
        });
      }
    },
    // 获取分成规则
    getSharingRuleList: function (cb) {
      this.$getJSON(apis.sharingRuleList, { productCode: this.productCode.split(',')[0] }).then((res) => {
        this.ruleList = res.data;
        cb();
      });
    },
    // 获取租赁方案列表
    getTableList: function () {
      this.$getJSON(apis.GoodsSkuList, { goodsId: this.goodsId }).then((res) => {
        const list = res.data;
        const arr = [];
        list.forEach((item) => {
          // 绑住值 如果数据存在（预防字典更新）/ 数据不存在
          if (item.sharingList) {
            const sharingList = [];
            this.ruleList.forEach((dic) => {
              const val = item.sharingList.find((f) => f.sharingClass === dic.sharingClass);
              sharingList.push(val || Object.assign({}, this.form, { sharingClass: dic.sharingClass, isFirstTerm: dic.sharingClass === item.deviceBizType ? 1 : 0 }));
            });
            item.sharingList = sharingList;
          } else {
            item.sharingList = JSON.parse(JSON.stringify(this.itemsForm));
          }
          // 融合旧数据
          const row = this.tableList.find((t) => t.goodsSkuId === item.goodsSkuId);
          arr.push(row || item);
        });
        this.tableList = arr;
      });
    },
    // 删除
    deleteEvent: function (data, index) {
      this.$showConfirm(this.$t('crm_lease_item_step_manage.nqdyscdqfam'))
        .then(() => {
          this.$postJSON(`${apis.GoodsSkuDelete}/${data.goodsSkuId}`).then(() => {
            this.tableList.splice(index, 1);
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
          });
        })
        .catch(() => {});
    },
    // 保存
    onSave: function () {
      const skuList = this.tableList.map((t) => ({
        goodsSkuId: t.goodsSkuId,
        additionalFee: t.additionalFee,
        depositFee: t.depositFee,
        unitPrice: t.unitPrice,
        sharingList: t.sharingList,
        giveawayMonth: t.giveawayMonth,
      }));
      const hasEmpty = skuList.find((t) => !`${t.additionalFee}` || !`${t.depositFee}` || !`${t.unitPrice}`);
      if (hasEmpty) {
        this.$message.error(this.$t('crm_lease_item_step_manage.qjxxtxwz'));
        return;
      }
      const list = skuList.map((t) => t.sharingList).reduce((pre, item) => [...pre, ...item], []);
      const isEmpty = list.find((t) => !`${t.afterServiceProfit}` || !`${t.agentCoProfit}` || !`${t.hqProfit}`);
      if (isEmpty) {
        this.$message.error(this.$t('crm_lease_item_step_manage.qjxxtxwz'));
        return;
      }
      const hasOneFirstTerm = skuList.every((t) => t.sharingList.filter((k) => k.isFirstTerm === 1).length === 1);
      if (!hasOneFirstTerm) {
        this.$message.error(this.$t('crm_lease_item_step_manage.qnjfadsqksblxszwz'));
        return;
      }
      this.$postJSON(apis.GoodsSkuUpdate, {
        goodsId: this.goodsId,
        skuList,
      }).then((res) => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });

        if (this.dialog) {
          this.$emit('success', res.data);
        } else {
          this.$emit('cancel');
        }
      });
    },
    // 新增方案弹窗
    addLeaseDialog: function () {
      this.dialogModel.title = this.$t('crm_lease_item_step_manage.tjzlfa');
      this.dialogModel.data = { goodsId: this.goodsId };
      this.dialogVisible = true;
    },
    // 统一设置
    onUnifiedDialog: function () {
      this.dialogModel1.title = this.$t('crm_lease_item_step_manage.szzlxx');
      this.dialogModel1.data = { itemsForm: this.itemsForm, deviceBizTypeList: this.tableList.map((t) => t.deviceBizType) };
      this.dialogVisible1 = true;
    },
    // 统一设置操作
    onUnifiedSuccess: function (data) {
      const { form, itemsForm } = data;
      this.tableList.forEach((item) => {
        item.depositFee = form.depositFee;
        item.unitPrice = form.unitPrice;
        item.additionalFee = form.additionalFee;
        item.giveawayMonth = form.giveawayMonth || 0;
        for (let i = 0; i < itemsForm.length; i++) {
          const arr = itemsForm[i].firstDeviceBizType || [];
          itemsForm[i].isFirstTerm = arr.includes(item.deviceBizType) ? 1 : 0;
        }
        item.sharingList = JSON.parse(JSON.stringify(itemsForm));
      });
    },
    // 违约方案
    onFalsifyDialog: function (data, isSetAll) {
      this.dialogModel2.title = this.$t('crm_lease_item_step_manage.szwyfa');
      this.dialogModel2.data = { row: { ...data, isSetAll } };
      this.dialogVisible2 = true;
    },
    // 预览
    onPreviewDialog: function (data) {
      this.dialogModel3.title = this.$t('crm_lease_item_step_manage.fen_cheng_ming_xi');
      this.dialogModel3.data = { row: data };
      this.dialogVisible3 = true;
    },
  },
};
</script>

<style lang="scss"></style>
